module.exports = __webpack_public_path__ + "img/performanceOfDiamonds.0601267.webp";